const FOLKS_AUTH_USER_DATA = "FOLKS_AUTH_USER_DATA";
const FOLKS_AUTH_USER_TOKEN = "FOLKS_AUTH_USER_TOKEN";

export { FOLKS_AUTH_USER_DATA, FOLKS_AUTH_USER_TOKEN };
